import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash';
import { AppComponent } from '../../app.component';
import { User } from '../../models/user';
import { AppStateService } from '../../services/app-state.service';
import { UtilsService } from '../../services/utils.service';
import { Subscription } from 'rxjs';
import { BillingService } from 'src/app/services/billing.service';
import { WalletPassService } from 'src/app/services/wallet-pass.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'a8-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidenavComponent implements OnInit, OnDestroy {
  today: Date = new Date();
  flags = {
    sidenav: false,
    userImg: 'none',
    walletLoading: false,
    claimLoading: false,
  };
  balanceText: string = '-';
  balance: number;
  subs: Subscription[] = [];
  user: User;

  constructor(
    public utils: UtilsService,
    private app: AppComponent,
    private router: Router,
    private billingService: BillingService,
    private walletPass: WalletPassService,
  ) {
    const user = this.utils.appState.user.subscribe((resp) => {
      this.user = resp;
      this.flags.userImg = this.getProfileBackground(this.user);
      this.getBalance();
    });
    this.subs.push(user);


    this.utils.appState.sidenav.subscribe((resp) => {
      this.flags.sidenav = resp;
    });

    if (!_.isEmpty(this.user)) {
      // DO SOMETHING
    }
  }

  ngOnInit() { }

  getBalance(){
    if (this.user?.isAuthenticated && this.user?.id) {
      this.billingService.getBalance().subscribe(data => {
        this.balanceText = '$' + data.balance.toFixed(2);
        this.balance = data.balance;
      });
    }
  }

  claim(){    
    if (this.flags.claimLoading) {
      return;
    }

    if(!this.user.has_bank_account){
      this.flags.claimLoading = true;
      this.billingService.addBankAccount().subscribe({
        next: (data) => {
          this.flags.claimLoading = false;
          if (data?.account_link) {
            window.open(data.account_link, '_self');
          } else {
            this.utils.alert.message('Bank account already connected.');
          }
        },
        error: (err) => {
          this.flags.claimLoading = false;
          const msg = err?.error?.detail || err?.message || 'Could not connect bank account.';
          this.utils.alert.error(msg);
        }
      });
      return;
    }

    this.flags.claimLoading = true;
    this.billingService.claimBalance({amount:this.balance}).subscribe({
      next: (data) => {
        this.flags.claimLoading = false;
        this.balanceText = '-';
        this.utils.alert.success(data?.detail || 'Money transferred to your stripe account.');
        this.getBalance();
      },
      error: (err) => {
        this.flags.claimLoading = false;
        const msg = err?.error?.detail || err?.error?.amount?.[0] || err?.message || 'Failed to claim balance.';
        this.utils.alert.error(msg);
      }
    });
  }

  async addToWallet() {
    this.flags.walletLoading = true;
    try {
      await this.walletPass.addToWallet();
      this.utils.alert.success('Added to Apple Wallet');
    } catch (error) {
      const message = error?.error?.detail || error?.message || 'Could not add the pass';
      this.utils.alert.error(message);
    } finally {
      this.flags.walletLoading = false;
    }
  }

  openExternal(link) {
    this.router.ngOnDestroy();
    window.open(link, '_blank');
  }

  clickLogin(){
    this.router.navigateByUrl('/login?returnUrl=' + this.router.url);
    this.closeSidenav();
  }

  closeSidenav(): void {
    // this.utils.sound('click-back');
    this.app.closeSideNav();

    // this.flags.sidenav = !this.flags.sidenav;
    this.utils.appState.sidenav.next(false);
  }

  getProfileBackground(profile){
    if(profile != null && profile.profile_pics != null && profile.profile_pics.photos && profile.profile_pics.photos.length > 0){
      return 'url('+ profile.profile_pics.photos[profile.profile_pics.photos.length-1].image.sm +')';
    }
    else{
      return 'none';
    }  
  }

  ngOnDestroy() {
    _.each(this.subs, (sub) => {
      sub.unsubscribe();
    });
  }

}
